import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/pcts/list", params, successCallback, failCallback, exceptionCallback);
	},
	//��ѯ�༶��ID
	listClass: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/pcts/listClass", params, successCallback, failCallback, exceptionCallback);
	},
	//��ѯ��༶��Ӧ��ѧ����ID
	listStuid: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/pcts/listStuid", params, successCallback, failCallback, exceptionCallback);
	},
	intnTcr(params, successCallback, failCallback, exceptionCallback) {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/pcts/intnTcr", params, successCallback, failCallback, exceptionCallback);
	},
	tuisong: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/pcts/tuisong", params, successCallback, failCallback, exceptionCallback);
	},
	save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/pcts/save", params, successCallback, failCallback, exceptionCallback);
	},
	save2push: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/pcts/submittedToPush2", params, successCallback, failCallback, exceptionCallback);
	},
	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/pcts/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/pcts/update", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/pcts/remove", params, successCallback, failCallback, exceptionCallback);
	},
}

export default api;
